import { inject, InjectionToken } from '@angular/core';

export const ORIGIN = new InjectionToken<string>('ORIGIN', {
    providedIn: 'root',
    factory: () => window.location.origin,
});

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL', {
    providedIn: 'root',
    factory: () => inject(ORIGIN) + '/api/v1',
});
